import { StoreState } from '../store'

export const selectOrganizationType = (state: StoreState) =>
  state.organization.type
